import { Auth as _Auth } from '@models/API/identity/auth.model';
import { Invitations as _Invitations } from '@models/API/identity/invitations.model';
import { User as _User } from '@models/API/identity/user.model';

export namespace Identity {
  export import Auth = _Auth;
  export import Invitations = _Invitations;
  export import User = _User;
}
